module.exports = __webpack_public_path__ + "img/img_4.e56ee254.png";